<template>
  <div class="page-deregistration">
    <notice :userInfo="userInfo" :noticeContent="noticeContent" @noticeCheck='onNoticeCheck' v-if="step === 1"></notice>
    <verification :app="app" :userInfo="userInfo" :verificationTip="verificationTip" @goBack="onGoBack" @goSuccess="onGoSuccess" v-if="step === 2"></verification>
    <success :app="app" :phone="userInfo.phone" v-if="step === 3"></success>
  </div>
</template>

<script>
import queryString from 'query-string'
import Notice from './components/Notice'
import Verification from './components/Verification'
import Success from './components/Success'
import { fetchInfo } from '@/api/member'
import fromApp from '@/utils/from'
import './index'

export default {
  data () {
    return {
      app: null,
      step: 1,
      userInfo: {},
      verificationTip: '',
      bindingTip: '',
      noticeContent: ''
    }
  },
  async created () {
    let userAppConfig = {}

    if (window.__MICRO_ROOT__) {
      const data = await window.__MICRO_ROOT__.cms.getPageData()

      if (data) {
        userAppConfig = data.config
      }
    }

    this.verificationTip = userAppConfig.verificationTip
    this.bindingTip = userAppConfig.bindingTip
    this.noticeContent = userAppConfig.noticeContent
    const params = queryString.parse(location.search)
    if (params.source === 'mobile' && params.userToken) {
      // 兼容移动端
      this.$ls.set('USER_CENTER_TOKEN', params.userToken, 2 * 60 * 60 * 1000)
    }
    this.fetch()
    this.app = fromApp()
    // 兼容ios13以上history跳转不触发刷新
    let isPageHide = false
    window.addEventListener('pageshow', function () {
      if (isPageHide) {
        window.location.reload()
      }
    })
    window.addEventListener('pagehide', function () {
      isPageHide = true
    })
  },
  methods: {
    async fetch () {
      try {
        const { user } = await fetchInfo({})
        this.userInfo = user
        // 更新用户缓存数据，用于绑定页面
        this.$ls.set('USER_CENTER_INFO', user)
      } catch (err) {
        this.$message.error(err.message)
      }
    },
    onNoticeCheck () {
      this.step = 2
    },
    onGoBack () {
      this.step = 1
    },
    onGoSuccess () {
      this.step = 3
    }
  },
  components: {
    notice: Notice,
    verification: Verification,
    success: Success
  }
}
</script>
